import { useStore } from '@nanostores/react';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { PromptAgentSelect } from '~/components/chat/PromptAgentSelect';
import { userCanUseClaudeCodeAgent, type SupportedAgents } from '~/lib/agents';
import { getDefaultAgent } from '~/lib/agents';
import { useChatAgent } from '~/lib/hooks/useChatAgent';
import { chatStore } from '~/lib/stores/chat';
import { userStore } from '~/lib/stores/user';

export const PromptAgentSelectContainer = () => {
  const chatStarted = useStore(chatStore.started);
  const user = useStore(userStore.user);
  const agent = useStore(chatStore.agentForNotStartedChat);
  const { agent: chatAgent, setAgent: setChatAgent } = useChatAgent();

  const onChange = async (agent: SupportedAgents) => {
    if (chatStarted) {
      await setChatAgent(agent);
    } else {
      chatStore.agentForNotStartedChat.set(agent);
    }
  };

  const selectedAgent = chatStarted ? chatAgent : agent;

  useEffect(() => {
    if (!agent && user) {
      chatStore.agentForNotStartedChat.set(getDefaultAgent(user));
    }
  }, [user]);

  if (!selectedAgent) {
    return null;
  }

  if (!userCanUseClaudeCodeAgent(user)) {
    return null;
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <PromptAgentSelect
        agent={selectedAgent}
        onChange={onChange}
        requireConfirmation={chatStarted}
        mode={chatStarted ? 'submenu' : 'dropdown'}
      />
    </motion.div>
  );
};
